import { Component, OnInit } from '@angular/core';
import { ProformaService } from '../../../services/proforma.service';
import { Proforma } from '../../../models/proforma';
import { SweetMessage } from '../../../config/sweet-message';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { ReporteModalComponent } from '../../modals/reporte-modal/reporte-modal.component';
import { SessionService } from '../../../services/session.service';
import { ReenviarCorreoComponent } from '../../modals/reenviar-correo/reenviar-correo.component';
import { ParametroService } from '../../../services/parametro.service';
import { Pagination } from '../../../models/pagination';

@Component({
  selector: 'app-proforma-list',
  templateUrl: './proforma-list.component.html',
  styleUrls: ['./proforma-list.component.css'],
  providers:[ProformaService, ParametroService]
})
export class ProformaListComponent implements OnInit {  

  public titulo: string;
  public loading: boolean;
  public proformas: Array<Proforma> = [];
  public msg: SweetMessage;
  public bsModalRef: BsModalRef;
  public proforma: Proforma;
  public numero_decimales: number;
  public format_decimal: String;
  public busqueda: String;
  public pagination: Pagination;

  constructor(
    public proformaService: ProformaService,    		
    private modalService: BsModalService,	
    private ss: SessionService,
    private parametroService: ParametroService,
  ) { 
    this.titulo = "Proforma";
    this.loading = false;
    this.msg = new SweetMessage();  
    this.numero_decimales = 2;
    this.format_decimal = "0,0.00";  
    this.busqueda = "";
    this.pagination = new Pagination();
  }

  ngOnInit() {
    let p1 = this.getParamNumeroDecimales();
    let p2 = this.getProformas();

    this.loading = true;
    Promise.all([p1,p2]).then(
      res => this.loading = false,
      err=> this.loading = false
    );
  }

  onSearch(event){
		this.busqueda = event.target.value;
		this.loading =true;
		this.getProformas().then(
			res => this.loading = false,
			err => this.loading = false
		);
		
  }

  getProformas() {
    return new Promise((resolve, reject)=>{
      let qs = "";
		
			if (this.busqueda != "") {
				qs = "&razon_social="+this.busqueda;
			}
      this.proformaService.getByFilter("?page="+this.pagination.current_page+"&per_page=10"+qs).subscribe(
        res => {
          
          this.proformas = res.data; 
          // Paginación
          this.pagination.current_page = res.current_page;
          this.pagination.from = res.from;
          this.pagination.to = res.to;
          this.pagination.total = res.total;
          this.pagination.last_page = res.last_page;
          this.pagination.next_disabled = (this.pagination.current_page === this.pagination.last_page);
          this.pagination.prev_disabled = this.pagination.current_page === 1;
          resolve();
        },
        err => {
          this.proformas = [];
          reject(err);
        }
      );
    });
  }

  getParamNumeroDecimales(){
      return new Promise((resolve, reject) => {
          let numero_decimales = 19;
          this.parametroService.getById(numero_decimales).subscribe(
              res => {
                  this.numero_decimales = res.valor;

                  let digitos = "";
                  for(let i = 0; i < this.numero_decimales; i++) digitos += "0";
                  this.format_decimal = "0,0." + digitos
                  resolve();
              },
              err => {
                  this.numero_decimales = 2;
                  this.format_decimal = "0,0.00"
                  reject(err);
              }
          );
      });
  }

  get formatDecimal(){
      return this.format_decimal;
  }

	onDelete(id){
		this.msg.showMessage('delete-confirm-message').then(
			res => {
				if(res == "ok"){
					this.proformaService.delete(id).subscribe(
						res => {
							if(res.message){
								this.getProformas();
								this.msg.showMessage('success-message',res.message);
							}
						},
						err => {
							this.msg.showMessage('error-message', err);
						}
					);
				}
			}
		);
	}

	onShow(id){
    let params = [];
    params["usuario_id"] = this.ss.getData('usuario_id');
    let qs = [];
    for(let key in params){
      let str = key + "=" + params[key];
      qs.push(str);
    }
    const initialState = {route: "proforma/" + id,  qs: "?" + qs.join("&")+ "&dbname="+this.ss.getData('dbname')};
		this.bsModalRef = this.modalService.show(ReporteModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
  }
  
  OnReenviar(id){
    this.msg.showMessage('delete-confirm-message', "¿Está seguro del envio?").then(
      res => {
          this.loading = true;
          this.proformaService.correo(id).subscribe(
              res => {
                this.loading = false;
                this.msg.showMessage('success-message', 'Se ha procesado correctamente ');                 
              },
              err => {
                this.loading = false;
                this.msg.showMessage('error-message',err);
              }
          );
        }
    );
  }

  next(){
    this.pagination.current_page++;
    this.getProformas();
  }

  prev(){
    this.pagination.current_page--;
    this.getProformas();
  }

  first(){
    this.pagination.current_page = 1;
    this.getProformas();
  }

  last(){
    this.pagination.current_page = this.pagination.last_page;
    this.getProformas();
  }

  getIndexNumber(i){
    return this.pagination.from+i;
  }


}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/ventas/proforma-list/proforma-list.component.ts